import { Loading } from '@whistler-ui/k2/components/Loading';
import { Fragment, PropsWithChildren } from 'react';

import { useBridgeKeeper } from '../../hooks/useBridgeKeeper';

type Feature =
  | string
  | 'watch_ui_v2'
  | 'devices_log'
  | 'devices_trace_test_view'
  | 'reports_use_cases'
  | 'health-status';

interface Props extends PropsWithChildren {
  feature: Feature;
  withLoader?: boolean;
  fallbackComponent?: React.ComponentType<object>;
}

/** Component to check if the logged user has access to a given feature */
// If no fallback component is passed an empty fragment is returned
export const BridgeKeeper = ({
  children,
  feature,
  withLoader,
  fallbackComponent,
}: Props) => {
  const { showFeature, isLoading } = useBridgeKeeper(feature);

  const Component = fallbackComponent ? fallbackComponent : Fragment;

  if (withLoader && isLoading) {
    return (
      <section className="h-screen flex items-center justify-center">
        <Loading />
      </section>
    );
  }

  return showFeature ? children : <Component />;
};
